import * as React from 'react';
import debounce from 'lodash/debounce';

interface DebouncedFunction extends Function{
  cancel:()=>void;
}
interface DebouncedArgs {
  wait?: number;
  maxWait?: number;
}
export function debounceRender<P>(ComponentToDebounce: React.ComponentClass, debounceArgs: DebouncedArgs = {wait: 5, maxWait: 200}) {
  class DebouncedContainer extends React.Component<any>{
    private requestRender: DebouncedFunction;

    public constructor(props: any) {
      super(props);

      this.requestRender = debounce(p => {
        this.forceUpdate();
      }, debounceArgs.wait, debounceArgs as any);
    }

    public componentWillUnmount() {
      this.requestRender.cancel();
    }

    public shouldComponentUpdate() {
      this.requestRender();
      return false;
    }

    public render(): JSX.Element {
      return <ComponentToDebounce { ...this.props } />;
    }
  }

  return DebouncedContainer;
}
